import borderRadius from '@helpers/borderRadius';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { contentStyles, displayStyles } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div ``;
const ThankYouMessage = styled.div `
  display: flex;
  align-items: center;
  column-gap: ${fluid(16, 24)};
  padding: ${fluid(16, 24)} 16px;
  background-color: ${brand.teal._100};
  border: 2px solid ${brand.teal.base};
  border-radius: ${fluid(borderRadius.xs, borderRadius.s)};
`;
const ThankYouIcon = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${fluid(32, 64)};
  height: ${fluid(32, 64)};
  border-radius: ${borderRadius.round}px;
  background-color: ${brand.teal.base};

  svg {
    width: ${fluid(16, 32)};
    height: ${fluid(12, 24)};
    color: ${brand.global.white};
  }
`;
const ThankYouMessageContent = styled.div `
  h2 {
    ${displayStyles};

    font-size: ${fluid(16, 20)};
    line-height: 20px;
    margin-bottom: ${fluid(4, 6)};
  }

  p {
    ${fonts.aptos.regular};

    font-size: ${fluid(13, 14)};
    line-height: ${fluid(19, 22)};
  }
`;
const NextSteps = styled.div `
  display: flex;
  margin-top: 24px;
`;
const NextStepsInner = styled.div `
  padding-bottom: 24px;
`;
const NextStepsHeading = styled.h3 `
  ${displayStyles};

  font-size: ${fluid(16, 18)};
  line-height: ${fluid(16, 18)};
  margin-bottom: 16px;
`;
const NextStepsList = styled.div `
  ${Container}[data-brief-steps='true'] & {
    @media ${from(Device.MobileLarge)} {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
      align-items: center;
      padding-top: 16px;
    }
  }
`;
const NextStepsIllustration = styled.div `
  display: none;
  position: relative;
  top: 12px;
  float: right;
  height: 100%;
  margin-left: 24px;
  align-items: flex-end;
  shape-outside: polygon(0 50%, 100% 50%, 100% 100%, 0% 100%);

  @media ${from(Device.MobileLarge)} {
    display: flex;
  }
`;
const StepItem = styled.div `
  position: relative;
  padding-left: 20px;

  &:not(:last-child) {
    margin-bottom: ${fluid(16, 24)};
  }

  ${Container}[data-brief-steps='true'] & {
    @media ${from(Device.MobileLarge)} {
      &:not(:last-child) {
        margin-bottom: 0;
      }
    }
  }
`;
const StepHeading = styled.h4 `
  ${displayStyles};

  font-size: 16px;
  line-height: 16px;
  margin-bottom: 6px;

  ${Container}[data-brief-steps='true'] & {
    @media ${from(Device.MobileLarge)} {
      margin-bottom: 0;
    }
  }
`;
const StepContent = styled.div `
  position: relative;

  @media ${from(Device.MobileLarge)} {
    position: static;
  }

  &::before {
    ${displayStyles};

    content: attr(data-index);
    position: absolute;
    left: -20px;
    top: 50%;
    transform: translateY(-50%) translateY(-5px);
    margin: 0;
    font-size: 80px;
    line-height: 50px;
    height: 50px;
    width: 40px;
    text-align: center;
    color: ${brand.orangeAccessible.base};
    opacity: 0.12;
    z-index: 0;

    @media ${from(Device.MobileLarge)} {
      left: 0;
    }
  }
`;
const StepContentInner = styled.div `
  ${contentStyles};

  p,
  li {
    font-size: ${fluid(13, 14)};
    line-height: ${fluid(19, 20)};
  }

  ${Container}[data-brief-steps='true'] & {
    @media ${from(Device.MobileLarge)} {
      display: none;
    }
  }
`;
export const SubmissionStyles = {
    Container,
    NextSteps,
    NextStepsHeading,
    NextStepsIllustration,
    NextStepsInner,
    NextStepsList,
    StepContent,
    StepContentInner,
    StepHeading,
    StepItem,
    ThankYouIcon,
    ThankYouMessage,
    ThankYouMessageContent,
};
